import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Use the same API base as the rest of the admin
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
// Backend URL without /api (for images)
const BACKEND_URL = API_BASE.replace('/api', '');

export default function AddProduct() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    slug: '',
    description: '',
    price: '',
    old_price: '',
    category: '',
    category_ar: '',
    brand: 'برولاكس',
    stock: 1,
    image_url: '',
    images: '[]',
    specs: '{}',
    featured: false,
    best_seller: false,
  });
  const [mainImage, setMainImage] = useState(null);
  const [preview, setPreview] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

 useEffect(() => {
  if (id) {
    fetch(`${API_BASE}/products`)
      .then(res => res.json())
      .then(products => {
        const product = products.find(p => p.id === Number(id));  // ← Fixed
        if (product) {
          setForm({
            name: product.name,
            slug: product.slug,
            description: product.description || '',
            price: product.price,
            old_price: product.old_price || '',
            category: product.category,
            category_ar: product.category_ar || '',
            brand: product.brand || 'برولاكس',
            stock: product.stock || 1,
            image_url: product.image_url || '',
            images: typeof product.images === 'string' ? product.images : JSON.stringify(product.images || []),
            specs: typeof product.specs === 'string' ? product.specs : JSON.stringify(product.specs || {}),
            featured: !!product.featured,
            best_seller: !!product.best_seller,
          });
          if (product.image_url) {
            setPreview(`${BACKEND_URL}${product.image_url}`);
          }
        }
      });
  }
}, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMainImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setSaving(true);

  try {
    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('slug', form.slug);
    formData.append('description', form.description);
    formData.append('price', form.price);
    formData.append('old_price', form.old_price || '');
    formData.append('category', form.category);
    formData.append('category_ar', form.category_ar);
    formData.append('brand', form.brand);
    formData.append('stock', form.stock);
    formData.append('images', form.images);
    formData.append('specs', form.specs);
    formData.append('featured', form.featured);
    formData.append('best_seller', form.best_seller);

    if (mainImage) {
      formData.append('main_image', mainImage);
    } else if (form.image_url) {
      formData.append('image_url', form.image_url);
    }

    const token = localStorage.getItem('brolax_admin_token');
    if (!token) throw new Error('يرجى تسجيل الدخول أولاً');

    const url = `${API_BASE}/products${id ? '/' + id : ''}`;
    console.log('Submitting to:', url);  // Debug

    const res = await fetch(url, {
      method: id ? 'PUT' : 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });

    // Check if response is JSON before parsing
    const contentType = res.headers.get('content-type');
    console.log('Content-Type:', contentType);  // Debug
    
    if (contentType && contentType.includes('application/json')) {
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'خطأ');
      navigate('/products');
    } else {
      const text = await res.text();
      console.error('Server returned non-JSON:', text);
      throw new Error('خطأ في الخادم - الرجاء التحقق من صحة البيانات');
    }
  } catch (err) {
    console.error('Submit error:', err);
    setError(err.message);
  } finally {
    setSaving(false);
  }
};

  return (
    <div className="max-w-4xl mx-auto text-white">
      <h2 className="text-3xl font-black mb-8">{id ? 'تعديل المنتج' : 'إضافة منتج جديد'}</h2>
      {error && <div className="bg-red-900/50 text-red-300 p-3 rounded-lg mb-6">{error}</div>}
      <form onSubmit={handleSubmit} className="bg-neutral-950 p-8 rounded-2xl border border-neutral-800 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-bold mb-1">اسم المنتج *</label>
            <input name="name" value={form.name} onChange={handleChange} required
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg" />
          </div>
          <div>
            <label className="block text-sm font-bold mb-1">الرابط (slug) *</label>
            <input name="slug" value={form.slug} onChange={handleChange} required
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg" />
          </div>
        </div>

        <div>
          <label className="block text-sm font-bold mb-1">الوصف</label>
          <textarea name="description" value={form.description} onChange={handleChange} rows="4"
            className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-bold mb-1">السعر *</label>
            <input name="price" type="number" value={form.price} onChange={handleChange} required
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg" />
          </div>
          <div>
            <label className="block text-sm font-bold mb-1">السعر القديم</label>
            <input name="old_price" type="number" value={form.old_price} onChange={handleChange}
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg" />
          </div>
          <div>
            <label className="block text-sm font-bold mb-1">المخزون</label>
            <input name="stock" type="number" value={form.stock} onChange={handleChange}
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-bold mb-1">الفئة</label>
            <select name="category" value={form.category} onChange={handleChange}
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg">
              <option value="blenders">خلاطات</option>
              <option value="air-fryers">قلايات هوائية</option>
              <option value="coffee-makers">ماكينات قهوة</option>
              <option value="food-processors">محضرات شراب وطعام</option>
              <option value="kettles">غلايات</option>
              <option value="microwaves">ميكروويف</option>
              <option value="toasters">مكانس</option>
              <option value="juicers">عصارات</option>
              <option value="rice-cookers">مراوح ومكيفات</option>
              <option value="slow-cookers">مستلزمات منزلية</option>
              <option value="steamers">مكوى البخارات</option>
              <option value="other">أخرى</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-bold mb-1">الفئة (عربي)</label>
            <input name="category_ar" value={form.category_ar} onChange={handleChange}
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg" />
          </div>
          <div>
            <label className="block text-sm font-bold mb-1">العلامة التجارية</label>
            <input name="brand" value={form.brand} onChange={handleChange}
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg" />
          </div>
        </div>

        {/* Image upload */}
        <div>
          <label className="block text-sm font-bold mb-1">الصورة الرئيسية</label>
          <input type="file" accept="image/*" onChange={handleFileChange}
            className="w-full p-2 bg-neutral-900 border border-neutral-700 rounded-lg" />
          {preview && <img src={preview} alt="معاينة" className="mt-2 w-32 h-32 object-cover rounded-lg" />}
        </div>

        <div className="flex gap-8">
          <label className="flex items-center gap-2 font-semibold">
            <input type="checkbox" name="featured" checked={form.featured} onChange={handleChange}
              className="w-5 h-5 accent-red-600" />
            منتج مميز
          </label>
          <label className="flex items-center gap-2 font-semibold">
            <input type="checkbox" name="best_seller" checked={form.best_seller} onChange={handleChange}
              className="w-5 h-5 accent-red-600" />
            الأكثر مبيعاً
          </label>
          {/* <label className="flex items-center gap-2 font-semibold">
            <input type="checkbox" name="on_sale" checked={form.old_price && form.old_price > form.price} readOnly
              className="w-5 h-5 accent-red-600" />
            خصم
          </label> */}
        </div>

        <button type="submit" disabled={saving}
          className="bg-red-600 text-white px-10 py-4 font-bold rounded-lg hover:bg-red-700 disabled:bg-neutral-700 transition">
          {saving ? 'جاري الحفظ...' : id ? 'تحديث المنتج' : 'إضافة المنتج'}
        </button>
      </form>
    </div>
  );
}